function getScales(relativeRatio) {
  const scaleMap = [
    { logo: 0.4, text: 0.4, threshold: 0.005 },
    { logo: 0.7, text: 0.6, threshold: 0.01 },
    { logo: 0.8, text: 0.8, threshold: 0.03 },
    { logo: 0.9, text: 0.9, threshold: 0.07 },
  ];

  for (const { logo, text, threshold } of scaleMap) {
    if (relativeRatio < threshold) {
      return { logoScale: logo, textScale: text };
    }
  }

  return { logoScale: 1, textScale: 1 };
}

export const getLabelConfig = (
  name,
  formattedColorValue,
  foregroundColor,
  logo: HTMLImageElement | null = null,
  showText = true,
  sizeValue = 0,
  visibleMaxValue = 1,
) => {
  const hasLogo = logo !== null;

  //used when zooming into chart
  const relativeRatio = Math.max(sizeValue / visibleMaxValue, 0.001);

  const { logoScale, textScale } = getScales(relativeRatio);
  const logoSize = hasLogo ? 40 * logoScale : 0;

  return {
    align: 'center',
    formatter: hasLogo
      ? showText
        ? `{logo|}\n{name|${name}}\n{value|${formattedColorValue}}`
        : `{logo|}`
      : showText
        ? `{name|${name}}`
        : '',
    padding: [2, 0, 0, 0],
    rich: {
      logo: {
        align: 'center',
        backgroundColor: hasLogo ? { image: logo } : undefined,
        height: logoSize,
        verticalAlign: 'middle',
        width: logoSize,
      },
      name: {
        align: 'center',
        color: foregroundColor,
        fontSize: 18 * textScale,
        fontWeight: '600',
        overflow: 'truncate',
        padding: [4, 0, 0, 0],
        verticalAlign: 'middle',
      },
      value: {
        align: 'center',
        color: foregroundColor,
        fontSize: 18 * textScale,
        fontStyle: 'italic',
        padding: [6, 0, 2, 0],
        verticalAlign: 'middle',
      },
    },
    show: true,
    verticalAlign: 'middle',
  };
};
